import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { faqs } from "@/mocks/faqs";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  return (
    <>
      <Navbar />
      <BackToTop />

      <section className="bg-primary-700 pt-24 pb-12 md:pt-28 md:pb-16">
        <div className="container-site">
          <nav aria-label="面包屑" className="text-xs text-primary-300">
            <ol className="flex flex-wrap items-center gap-1.5">
              <li><Link to="/" className="hover:text-background-50">首页</Link></li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
              <li aria-current="page" className="text-accent-300">常见问题</li>
            </ol>
          </nav>
          <h1 className="mt-4 text-2xl font-bold text-background-50 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-primary-100 md:text-base">
            关于《天才医仙漫画》的剧情、医术修炼体系、境界顺序等高频问题，集中在这里解答。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="container-site grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="sticky top-24 rounded-lg border border-background-200/80 bg-background-100/60 p-6">
              <h2 className="font-heading text-lg font-bold">还想了解更多？</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                如果这里没有你要的答案，可以先去修炼体系页或六大境界文章里找找，那里有更完整的内容。
              </p>
              <div className="mt-5 space-y-2.5">
                <Link
                  to="/xiulian"
                  className="flex items-center justify-between rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  修炼体系
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/article/yi-xian-zhi-lu"
                  className="flex items-center justify-between rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
                >
                  六大境界详解
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>

          <div className="space-y-3 lg:col-span-3">
            {faqs.map((f, i) => (
              <details
                key={f.q}
                className="group rounded-lg border border-background-200/80 bg-background-100/60 p-5"
                open={i === 0}
              >
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-heading text-base font-bold text-foreground-900">
                  {f.q}
                  <i className="ri-add-line text-xl text-foreground-500 transition-transform group-open:rotate-45" aria-hidden="true"></i>
                </summary>
                <p className="mt-3 text-sm leading-7 text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <Footer />
    </>
  );
}